import { render } from "./DoctorSearchBar.vue?vue&type=template&id=4356c9da&scoped=true"
import script from "./DoctorSearchBar.vue?vue&type=script&lang=js"
export * from "./DoctorSearchBar.vue?vue&type=script&lang=js"

import "./DoctorSearchBar.vue?vue&type=style&index=0&id=4356c9da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4356c9da"]])

export default __exports__